import React, {Component} from 'react';
import Modal from 'react-modal';

class ProgressModal extends Component {

    constructor(props) {
        super(props);
        this.beforeUnload = this.beforeUnload.bind(this);
        this._dismissUpload = this._dismissUpload.bind(this);
    }

    componentDidMount() {
        const { isUploading, isSavingFirebase } = this.props;
        if ( isUploading === true || isSavingFirebase === true ) {
            window.addEventListener('beforeunload', this.beforeUnload);
        }
    }

    componentDidUpdate() {
        const { isProcessCompleted, isProcessError } = this.props;
        if ( isProcessCompleted === true || isProcessError === true ) {
            window.removeEventListener('beforeunload', this.beforeUnload);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.beforeUnload); 
    }

    beforeUnload(event) {
        const confirmationMessage = 'This page is asking you to confirm that you want to leave - data you have entered may not be saved.';
        event.returnValue = confirmationMessage;
        return confirmationMessage;
    }

    _dismissUpload() {
        const { isUploading, isSavingFirebase } = this.props;
        if ( isUploading === true || isSavingFirebase === true ) {
            var result = window.confirm('Are you sure to cancel upload ?');
            if ( result === true ) {
                this.props.dismissUpload();
            }
        }
        else {
            this.props.dismissUpload();
        }
    }

    render() {
        const { 
            isOpen, 
            isUploading, 
            isSavingFirebase, 
            isProcessCompleted, 
            isProcessError, 
            uploadPercentage 
        } = this.props;
        var uploadProgressHeading = 'อัพโหลดไฟล์...';
        var uploadProgressDescription = 'กรุณาเปิดหน้านี้ไว้จนกว่าการบันทึกข้อมูลเสร็จสิ้น';
        var uploadPercentageValue = 0;
        if ( isUploading === true && uploadPercentage !== undefined ) {
            uploadProgressHeading += ' ' + uploadPercentage + '%';
            uploadPercentageValue = uploadPercentage;
        }
        else if ( isSavingFirebase === true ) {
            uploadProgressHeading = 'บันทึกข้อมูล...';
            uploadPercentageValue = 100;
        }
        else if ( isProcessCompleted === true ) {
            uploadProgressHeading = 'อัพโหลดสำเร็จ';
            uploadProgressDescription = 'ข้อมูลของคุณได้ถูกบันทึกบนระบบเรียบร้อยแล้ว';
            uploadPercentageValue = 100;
        }
        else if ( isProcessError === true ) {
            uploadProgressHeading = 'เกิดข้อผิดพลาด';
            uploadProgressDescription = 'การเชื่อมต่อขัดข้อง กรุณาลองใหม่อีกครั้ง';
            uploadPercentageValue = ( uploadPercentage !== undefined ) ? uploadPercentage : 0;
        }
        return ( 
            <Modal
                isOpen={isOpen} 
                contentLabel="Uploading..." 
                onRequestClose={this._dismissUpload} 
                className="modal is-active"
                overlayClassName="modal-overlay"
                htmlOpenClassName="ReactModal__Html--open" >
                <div className="modal-background"></div>
                <div className="modal-content modal-alert">
                    <div className="UploadProgressContentBox box">
                        <div className="content">
                            <h4 className="UploadProgressHeading title is-size-4 is-size-5-mobile has-text-white">{uploadProgressHeading}</h4>
                            <p className="UploadProgressDescription">{uploadProgressDescription}</p>
                            <progress className="UploadProgressBar progress is-primary" value={uploadPercentageValue} max="100">{uploadPercentageValue}%</progress>
                        </div>
                        {/* <a className="UploadProgressClose icon is-large has-text-grey" onClick={this._dismissUpload}><i className="fas fa-times"></i></a> */}
                    </div>
                </div>
            </Modal>
        );
    }

}

export default ProgressModal;


// WEBPACK FOOTER //
// ./src/PageManagement/_ProgressModal.js